import axios from "axios";
const api = axios.create({
 baseURL: "https://ahplgtroad.amandeephospital.org/api",
 //  baseURL: "http://localhost:8000/api",
});
export default api;
